export default __webpack_public_path__ + "static/quero-meu-filho-kd-66ab8db6e4a92bdd703b704240459a6f.png";